module.exports = __webpack_public_path__ + "static/media/cg3.353ed072.png";